import { RenderTextInput } from "app/common/renderInput";
import React, { useRef } from "react";
import DatePicker, { CalendarContainer } from "react-datepicker";
const calenderCheckIn = ({ className, children }) => {
  return (
    <div>
      <CalendarContainer className={className}>
        <div
          style={{ background: "#f0f0f0" }}
          className="text-primary text-center shadow-sm"
        >
          <strong style={{ fontSize: 16 }}>Check-In</strong>
        </div>
        <div style={{ position: "relative" }}>{children}</div>
      </CalendarContainer>
    </div>
  );
};
const calenderCheckout = ({ className, children }) => {
  return (
    <div>
      <CalendarContainer className={className}>
        <div
          style={{ background: "#f0f0f0" }}
          className="text-primary text-center shadow-sm"
        >
          <strong style={{ fontSize: 16 }}>Check-Out</strong>
        </div>
        <div style={{ position: "relative" }}>{children}</div>
      </CalendarContainer>
    </div>
  );
};
export default function BookingDetails({
  values,
  setFieldValue,
  handleChange,
  touched,
  handleBlur,
  errors,
}) {
  const checkOutRef = useRef(null);
  return (
    <div>
      <div className="row">
        <div className="col-md-6 mb-3">
          <label style={{ fontWeight: "bold" }}>
            Booking Id <span style={{ color: "red" }}>*</span>
          </label>
          <RenderTextInput
            type="text"
            name="bookingId"
            // display="Affiliate Service"
            placeholder="Booking Id"
            value={values?.bookingId}
            error={errors.bookingId}
            onChange={(e) => {
              handleChange(e);
            }}
            onBlur={handleBlur}
            touched={touched.bookingId}
          ></RenderTextInput>
        </div>
        <div className="col-md-6 mb-3">
          <label htmlFor="firstName" className="heading">
            HSN Number <span style={{ color: "red" }}>*</span>
          </label>
          <RenderTextInput
            type="number"
            name="hsnNumber"
            // display="Affiliate Service"
            placeholder="HSN Number"
            value={values?.hsnNumber}
            error={errors.hsnNumber}
            onChange={(e) => {
              handleChange(e);
            }}
            onBlur={handleBlur}
            touched={touched.hsnNumber}
          ></RenderTextInput>
        </div>
        <div className="col-md-6 mb-3">
          <label htmlFor="checkOutDate" className="heading mb-4">
            Check-In<span className="text-danger">*</span>
          </label>
          <DatePicker
            showIcon
            className="form-select"
            dateFormat="dd-MM-yyyy"
            selected={values?.CheckInDate}
            withPortal
            onChange={(date) => {
              // Set Check-in Date
              setFieldValue("CheckInDate", date);

              // Auto-set Check-out Date = Check-in Date + 1 day
              const nextDay = new Date(date);
              nextDay.setDate(nextDay.getDate() + 1);
              setFieldValue("CheckOutDate", nextDay);

              // Open the Check-out calendar
              setTimeout(() => {
                checkOutRef.current?.setOpen(true);
              }, 300); // slight delay to ensure state updates before opening
            }}
            calendarContainer={calenderCheckIn}
          />

          <div className="error-label">{errors?.CheckInDate}</div>
        </div>

        <div className="col-md-6 mb-3">
          <label htmlFor="checkOutDate" className="heading mb-4">
            Check-Out<span className="text-danger">*</span>
          </label>

          <DatePicker
            ref={checkOutRef}
            withPortal
            className="form-select"
            dateFormat="dd-MM-yyyy"
            selected={values?.CheckOutDate}
            minDate={values?.CheckInDate}
            calendarContainer={calenderCheckout}
            onChange={(date) => {
              setFieldValue("CheckOutDate", date);
            }}
          />

          <div className="error-label">{errors?.CheckOutDate}</div>
        </div>
      </div>
    </div>
  );
}
